import { stdnum } from "stdnum";

import { CountryCode } from "../types/common";

export interface IOrgNumValidatorResult {
  formatted: string;
  compact: string;
  isValid: boolean;
}

export const orgNumValidator = (
  value: string,
  countryCode: CountryCode,
): IOrgNumValidatorResult => {
  switch (countryCode) {
    case CountryCode.SE: {
      const seOrgnr = stdnum[countryCode]?.orgnr;
      if (!seOrgnr)
        throw new Error("Swedish organisation number validator not available");
      return {
        formatted: seOrgnr.format(value),
        compact: seOrgnr.compact(value),
        isValid: seOrgnr.validate(value).isValid,
      };
    }

    case CountryCode.FI: {
      const fiYtunnus = stdnum[countryCode]?.ytunnus;
      if (!fiYtunnus)
        throw new Error("Finnish organisation number validator not available");
      return {
        formatted: fiYtunnus.format(value),
        compact: fiYtunnus.compact(value),
        isValid: fiYtunnus.validate(value).isValid,
      };
    }

    default:
      throw new Error(`Country code [${countryCode}] not supported`);
  }
};
